// How a Predict response is read for display. Pure: no React, no I/O.

// Same marker as backend chatbot/llm/parse_prediction.py MANUAL_REVIEW_PREFIX.
export const MANUAL_REVIEW_PREFIX = 'MANUAL REVIEW REQUIRED:';

// A case that needs a person: never shown as accepted or as a final rejection (the API status is "Rejected").
// The structured review_required flag decides; the reason marker is read only when an older API omits the flag.
export const needsManualReview = (data) => (typeof data?.review_required === 'boolean'
    ? data.review_required
    : data?.warranty_status === 'Rejected' && typeof data?.reason === 'string' && data.reason.startsWith(MANUAL_REVIEW_PREFIX));

export const stripManualReviewPrefix = (reason) => (reason.startsWith(MANUAL_REVIEW_PREFIX)
    ? reason.slice(MANUAL_REVIEW_PREFIX.length) : reason).trim();

// Reason codes the prediction may return, with their display text.
export const REASON_CODE_LABELS = new Map([
    ["ACP", "Warranty claim accepted."],
    ["PID", "Incorrect, ineligible, or improperly identified Part Number Main Cause (PNMC) or related part."],
    ["QTY", "Incorrect quantity or usage of PNMC or related part."],
    ["LOP", "Invalid or incorrect labor operation (LO)."],
    ["ATH", "Claim requires pre-authorization or submission authorization."],
    ["DSA", "Dealer Self-Authorization (DSA) error."],
    ["TML", "Claim, resubmission, or appeal submitted past the allowed deadline."],
    ["DUP", "Duplicate claim or repeat repair."],
    ["CMP", "Conflict with Campaign/Recall/SSP/Process Number requirements."],
    ["WEX", "General warranty coverage for the claimed repair has expired."],
    ["DCO", "Incorrect, missing, or improperly formatted data."],
    ["SUB", "Error in sublet claim."],
    ["BAT", "Battery claim non-compliance."],
    ["NPF", "No Problem Found (NPF) procedure violation."],
    ["BRV", "Claim on a branded title vehicle where warranty is void."],
    ["APL", "Appeal process error."],
    ["DOC", "Required documentation or claim text missing or incomplete."],
    ["TSB", "Non-compliance with Technical Service Bulletin (TSB) requirements."],
    ["PGM", "Vehicle programming/software issue."],
    ["FIN", "Financial error in claim total or amounts."],
    ["RNT", "Rental claim error."],
    ["MSC", "Miscellaneous policy violation or system error."]
]);
